var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 84,
    viewBox: "0 0 146 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_27601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.666 36.9902H21.6677C21.6677 106.58 78.0761 162.999 147.666 162.999V144.998C88.0149 144.998 39.666 96.6412 39.666 36.9902Z",
    fill: "#1BC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.666 -34.9991V-53C97.9563 -53 57.6667 -12.7104 57.6667 36.9912C57.6667 86.7007 97.9563 127.001 147.666 127.001V109C107.898 109 75.6676 76.7619 75.6676 36.9938C75.6676 -2.76102 107.897 -34.9991 147.666 -34.9991Z",
    fill: "#1BC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.666 -17.002C117.836 -17.002 93.666 7.16831 93.666 36.9901C93.666 66.8198 117.836 90.998 147.666 90.998V36.998L201.666 36.9901C201.666 7.16831 177.498 -17.002 147.666 -17.002Z",
    fill: "#1BC5BD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_27601"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H134C140.627 0 146 5.37258 146 12V72C146 78.6274 140.627 84 134 84H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.b4754687575e376026ce9f675ee7df08.svg";
export { ForwardRef as ReactComponent };